import { useEffect, useState } from 'react';
import wabysLogo from '../../assets/wabys.png';
import person from "../../assets/person.jpg";
import { wisdomFetchCROData } from 'services/dashboard';

const CroReport = ({ pdfRef, selectedOrgId, selectedMonthIdx }) => {
    const [croData, setCroData] = useState([]);
    const [filteredCroData, setFilteredCroData] = useState([]);

    // fetch wisdom dashboard data
    useEffect(() => {
        const loadData = async () => {
            const response = await wisdomFetchCROData();

            setCroData(response);
        };

        loadData();
    }, []);

    // arrange and filter CRO data
    useEffect(() => {
        const arrangeCro = () => {
            const arrangeData = croData.map(item => {
                const months = item.months || [];
                return months[months.length - 1];
            });
            setFilteredCroData(arrangeData);
        };

        arrangeCro();
    }, [croData]);

    useEffect(() => {
        const filterCROData = async () => {
            if (!croData || croData.length === 0) return; // data not ready

            if (selectedOrgId !== "All") {
                const result = croData.find(obj => obj.id === selectedOrgId);

                if (!result || !result.months) {
                    console.warn("No matching org or months data found for:", selectedOrgId);
                    setFilteredCroData([]);
                    return;
                }

                const monthData = result.months[selectedMonthIdx] || result.months.at(-1);
                setFilteredCroData([monthData]);
            } else {
                const arrangeData = croData.map(item => {
                    const months = item.months || [];
                    return months[months.length - 1];
                });
                setFilteredCroData(arrangeData);
            }
        };

        filterCROData();
    }, [selectedMonthIdx, selectedOrgId, croData]);

    return (
        <div ref={pdfRef} className="relative bg-white w-[40%] max-w-5xl h-fit p-4 flex flex-col mt-4 text-black">
            {/* Header */}
            <div className="flex justify-between items-center w-full">
                {/* logo */}
                <div className="flex flex-col items-center w-14">
                    <img src={wabysLogo} className="w-14" alt="ebda edu logo" />
                </div>
                {/* title */}
                <div className="flex flex-col items-center gap-2 text-xs font-bold">
                    <h1 className="border-b-2 border-black text-black">تقرير توصيات توجيه مؤشر الاداء</h1>
                    <h1 className="border-b-2 border-black text-black"> لتنمية الجوانب المهنية</h1>
                </div>
                {/* logo */}
                <div className="flex flex-col">
                    <img src={wabysLogo} className="w-14" alt="ebda edu logo" />
                </div>
            </div>
            {filteredCroData.map((data, idx) => data.reports.length > 0 && data.reports.map(report => <div className="rounded-xl shadow-black shadow-md p-2 flex flex-col mt-2 w-full gap-2">
                <div className="w-full border-black border-2 flex p-1 gap-1 min-h-20">
                    <div className="flex flex-col items-center text-center gap-1 w-[15%] font-bold">
                        <div className="text-[10px] border-black border-2 w-full bg-gray-300 h-1/2 flex justify-center items-center">متوسط التقييم</div>
                        <div className="text-sm border-black border-2 w-full h-1/2 flex justify-center items-center">{report.scores.reduce((sum, item) => sum + (item.avg_score || 0), 0) / (report.scores.length || 1)}%</div>
                    </div>
                    <div className="flex flex-col gap-1 w-2/3 text-[10px] font-bold justify-center items-center">
                        <div className="border-black border-2 h-fit w-full text-center px-2 py-1 flex justify-center items-center">{report.name}</div>
                        <div className="border-black border-2 h-fit w-full text-center px-2 py-1 flex justify-center items-center">{report.authority}</div>
                        <div className="border-black border-2 h-fit w-full text-center px-2 py-1 flex justify-center items-center">{report.subject}</div>
                    </div>
                    <div className="flex flex-col gap-1 min-w-fit max-w-1/3 text-[10px] font-bold justify-center items-center">
                        <div className="border-black border-2 h-fit w-full text-center px-2 py-1 flex justify-center items-center bg-gray-300">الاسم</div>
                        <div className="border-black border-2 h-fit w-full text-center px-2 py-1 flex justify-center items-center bg-gray-300">الجهة الرئيسية</div>
                        <div className="border-black border-2 h-fit w-full text-center px-2 py-1 flex justify-center items-center bg-gray-300">التخصص</div>
                    </div>
                    <div className="border-black border-2 p-1 flex items-center">
                        <img className="w-16" src={person} alt="" />
                    </div>
                    <div className="flex justify-center items-center">
                        <div className="px-2 bg-gray-300 border-black border-2 text-xs">{idx}</div>
                    </div>
                </div>
                <div className="border-2 border-black m-2 p-2 rounded-md overflow-x-auto">
                    <table className="w-full border-collapse text-center">
                        <thead className="bg-gray-100">
                            <tr className="border-b border-black">
                                <th className="min-w-[15%] w-[15%] py-2 border-black border-r-2">التوصية</th>
                                <th colSpan={2} className="min-w-[40%] w-[40%] py-2 border-black border-x-2">
                                    النسبة
                                </th>
                                <th className="min-w-[45%] w-[45%] py-2 border-black border-l-2">العنوان</th>
                            </tr>
                        </thead>

                        <tbody>
                            {report.scores.map((score, i) => (
                                <tr key={i} className="border-b last:border-0 hover:bg-gray-50">
                                    {/* التوصية */}
                                    <td className="py-2 text-xs font-medium border-black border-r-2">
                                        {score.recommendation}
                                    </td>

                                    {/* النسبة (الرقم) */}
                                    <td className="py-2 font-bold text-sm w-[15%]">{score.avg_score}%</td>

                                    {/* النسبة (الشريط) */}
                                    <td className="py-2 w-[25%]">
                                        <div className="w-[95%] h-5 bg-[#444652] rounded-full shadow-inner relative overflow-hidden">
                                            <div
                                                className="h-full rounded-full transition-all duration-700 ease-[cubic-bezier(.4,2,.6,1)]"
                                                style={{
                                                    width: `${score.avg_score}%`,
                                                    backgroundColor: `${score.avg_score <= 50 ? "red" : score.avg_score <= 60 ? "#FFDE21" : score.avg_score <= 70 ? "orange" : score.avg_score <= 80 ? "green" : "#274AB3"}`,
                                                }}
                                            />
                                        </div>
                                    </td>

                                    {/* العنوان */}
                                    <td className="py-2 text-xs font-medium text-end border-black border-l-2">
                                        {score.field_name}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>))}
        </div>
    )
};

export default CroReport;